import { Platform } from 'react-native';
import { Dimensions } from 'react-native';
import CreateResponsiveStyle from './responsiveStyle';
export const GlobalVariables = {
	localStorage:{
		token: '@tokenUser',
	},
	vars: {
		whatsappLink: 'https://api.whatsapp.com/send?phone=5215580466181&text=Hola&type=phone_number&app_absent=0',
		width: Dimensions.get('window').width,
		widthMobile: 860,
		api: 'http://localhost:8081/',
		//api: 'http://10.82.11.170:8180/',
		//api: 'https://servicios.lmedpolanco.com/',

// -> ALMP
		lab: 'POLANCO',
		url: 'https://lmpolanco.com/',
		txt: 'Ir al sitio principal LMP',
		wur: 'https://api.whatsapp.com/send?phone=5215580466181&text=Hola&type=phone_number&app_absent=0',
		hpe: '../source/image/ejemplo-expediente.png',
		hpv: '../source/image/ejemplo-visita.png',
		log: '../source/icons/logo-lmp-completo.png',

// -> RUIZ
//		lab: 'RUIZ',
//		url: 'https://laboratoriosruiz.com/',
//		txt: 'Ir al sitio principal RUIZ',
//		wur: 'https://api.whatsapp.com/send?phone=5215580466180&text=Hola&type=phone_number&app_absent=0',
//		hpe: '../source/image/ejemplo-expediente-ruiz.png',
//		hpv: '../source/image/ejemplo-visita-ruiz.png',
//		log: '../source/icons/logo-ruiz-completo.png',

		dataTokenUser: {
			username: 'marco.mendoza',
			password: 'marco.mendoza',
		},
  },
  colors: {
    primary: {
      kingBlue: '#001689',
      orange: '#EE760C',
      darkGrey: '#333333',
      blue: 'linear-gradient(180deg, #4B93D0 0%, #3157A4 100%)',
      whiteOrange: 'linear-gradient(180deg, #FAB336 0%, #EF7C11 44%, #EE760C 100%)',
      textColorBlue: '#002395',
      modal: 'rgba(0, 0, 0, 0.50)',
    },
    secondary: {
      lightBlue: '#D4EDFC',
      brightBlue: '#00B6ED',
      redWarning: '#FF4600',
      lightGrey: '#E3E6E7',
      white: '#FFFFFF',
    },
  },
  class: CreateResponsiveStyle({
    primaryLink: {
      color: '#001689',
      fontFamily: '"Helvetica Neue LT Std Roman", sans-serif',
      textDecorationLine: 'underline',
      fontSize: 18,
      lineHeight: 24,
      ...Platform.select({
        web: {
          cursor: 'pointer',
        },
        android: {
          marginTop: 40,
          marginBottom: 30,
        },
      }),
    },
    generalContainer: {
      position: 'relative',
      height: Dimensions.get('window').height,
    },
    iconWhatsapp: {
      position: 'absolute',
      right: 40,
      bottom: 30,
      ...Platform.select({
        web: {
          cursor: 'pointer',
        },
      }),
    },
  }, {
    iconWhatsapp: {
      display: 'none',
      bottom: 25,
      right: 20,
      ...Platform.select({
        android:{
          bottom: 40,
        },
      }),
    },
  }),
  patterns: {
    email: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
    text: /\S+/,
    number: /[^0-9]/g,
    decimal: /^\d{1,}(\.\d{0,4})?$/g,
    phoneNumber: /^\d{10}$/,
    curp: /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
    dateOne: /^(0?[1-9]|[12][0-9]|3[01])[/-](0?[1-9]|1[012])[/-]\d{4}$/,//format dd/mm/yyy
    rfc: /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/,
    symbols: /[&/\\#,+()$~%.'":*?<>{}]/g,//valida que no existan simbolos "",.: etc..
    zipCode: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
  },
};
